import React  from "react";
import { FooterMenu } from './Footer.Menu'
import { Box, Container, Flex, Text, } from "theme-ui";
import { StaticImage } from "gatsby-plugin-image";
import { Link as GLink } from "gatsby";

const styles = {
    wrapper: {
      position: `relative`,
      bg: `footerBg`,
      mt: [5, 6]
    },
    flexItem: {
        flexBasis: '1/5',
        display: 'flex',
        flexDirection:'column',
        justifyContent: 'center',
        textAlign: 'center',
    }
  }

export const Footer = () => {
    
    return(
    <Box sx={styles.wrapper} >
        <Container variant='compact' sx={styles.container}>
            <Flex variant='layout.footer'>
                <FooterMenu />
                <Box sx={styles.flexItem}>
                <StaticImage src="../../assets/images/community-fund.png" />
                </Box>
                <Box sx={styles.flexItem}>
                <StaticImage src="../../assets/images/cca.png" />
                <Text sx={{color:'white', mb:2}}>Member of Community Chaplaincy Association</Text>
                </Box>
                <Box sx={styles.flexItem}>
                <StaticImage src="../../assets/images/hiwcf.png" height={100} />
                <Text sx={{color:'white', mb:2}}>Hampshire Isle of Wight Community Foundation</Text>
                <Text sx={{color:'white', fontWeight:'700'}}>2020/21 Award recipient</Text>
                </Box>
                <Box  sx={styles.flexItem}>
                <Box as={GLink} to='/'><StaticImage src="../../assets/images/logo.png" /></Box>
                <Text sx={{color:'white', fontWeight:'700', my:2}}>Registered charity 1192181</Text>
                <Text sx={{color:'white', textAlign: [null,"left"], pl:3}}>Director Generals House <br/>15 Rockstone Place Southampton <br/> Hampshire SO15 2EP</Text>
                </Box>
            </Flex>
        </Container>
    </Box>
    )
}
